'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { Button } from '@/shared/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/dialog';
import { Loader } from '@/shared/ui/loader';
import { useSearchCities } from '../model/useSearchCities';
import { CityList } from './CityList';
import { SearchSection } from './SearchSection';
import btnIcons from '@/shared/assets/sprites/btns.sprite.svg';
import type { ICity } from '@/entities/common/types/city';
interface SelectCityModalProps {
  isOpen: boolean;
  currentCityAlias: string;
  onClose: () => void;
}
const POPULAR_CITIES: ICity[] = [{
  id: 1,
  name: 'АЛМАТЫ',
  alias: 'almaty'
}, {
  id: 4,
  name: 'АСТАНА',
  alias: 'astana'
}, {
  id: 7,
  name: 'АКТАУ',
  alias: 'aktau'
}, {
  id: 10,
  name: 'ШЫМКЕНТ',
  alias: 'shymkent'
}, {
  id: 13,
  name: 'КАРАГАНДА',
  alias: 'karaganda'
}, {
  id: 16,
  name: 'ТАЛДЫКОРГАН',
  alias: 'taldykorgan'
}, {
  id: 19,
  name: 'АТЫРАУ',
  alias: 'atyrau'
}, {
  id: 2,
  name: 'КЫЗЫЛОРДА',
  alias: 'kyzylorda'
}, {
  id: 5,
  name: 'СЕМЕЙ',
  alias: 'semey'
}, {
  id: 8,
  name: 'КОСТАНАЙ',
  alias: 'kostanay'
}, {
  id: 11,
  name: 'ТЕМИРТАУ',
  alias: 'temirtau'
}, {
  id: 14,
  name: 'ПЕТРОПАВЛОВСК',
  alias: 'petropavlovsk'
}, {
  id: 17,
  name: 'УРАЛЬСК',
  alias: 'uralsk'
}, {
  id: 20,
  name: 'КОКШЕТАУ',
  alias: 'kokshetau'
}, {
  id: 3,
  name: 'АКТОБЕ',
  alias: 'aktobe'
}, {
  id: 6,
  name: 'ТАРАЗ',
  alias: 'taraz'
}, {
  id: 9,
  name: 'ПАВЛОДАР',
  alias: 'pavlodar'
}, {
  id: 12,
  name: 'ТУРКЕСТАН',
  alias: 'turkestan'
}, {
  id: 15,
  name: 'УСТЬ-КАМЕНОГОРСК',
  alias: 'ust-kamenogorsk'
}, {
  id: 18,
  name: 'ЭКИБАСТУЗ',
  alias: 'ekibastuz'
}, {
  id: 21,
  name: 'ЖЕЗКАЗГАН',
  alias: 'zhezkazgan'
}];
export const SelectCityModal: React.FC<SelectCityModalProps> = ({
  isOpen,
  currentCityAlias,
  onClose
}) => {
  const t = useTranslations('shared.header');
  const {
    query,
    isLoading,
    searchResults,
    isEmptySearch,
    handleSearchChange,
    onSearchFocus
  } = useSearchCities();
  const citiesToShow = query.length > 2 ? searchResults : POPULAR_CITIES;
  const showSearchResults = query.length > 2;
  return <Dialog open={isOpen} onOpenChange={onClose} data-sentry-element="Dialog" data-sentry-component="SelectCityModal" data-sentry-source-file="index.tsx">
      <DialogContent className="h-dvh min-h-dvh overflow-y-scroll md:h-auto md:min-h-[auto] md:w-full md:max-w-3xl md:overflow-y-hidden md:rounded-3xl" overlayClick={onClose} data-sentry-element="DialogContent" data-sentry-source-file="index.tsx">
        <DialogHeader data-sentry-element="DialogHeader" data-sentry-source-file="index.tsx">
          <DialogTitle className="flex items-center justify-between" data-sentry-element="DialogTitle" data-sentry-source-file="index.tsx">
            <div className="flex items-center gap-2">
              <SearchSection searchQuery={query} onSearchChange={handleSearchChange} onSearchFocus={onSearchFocus} data-sentry-element="SearchSection" data-sentry-source-file="index.tsx" />
            </div>

            <Button variant="circle" className="size-12 min-w-12 bg-bgSecondary" onClick={onClose} data-sentry-element="Button" data-sentry-source-file="index.tsx">
              <svg className="size-6 rotate-180 stroke-textPrimary" data-sentry-element="svg" data-sentry-source-file="index.tsx">
                <use xlinkHref={`${btnIcons}#close`} data-sentry-element="use" data-sentry-source-file="index.tsx"></use>
              </svg>
            </Button>
          </DialogTitle>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto">
          {showSearchResults && isEmptySearch && <div className="flex h-full flex-col items-center justify-center py-8">
              <p className="text-center text-base text-black">
                {t('searchResults.not_found')}
                <br />
                {t('searchResults.try_again')}
              </p>
            </div>}

          {showSearchResults && isLoading && <div className="flex h-full flex-col items-center justify-center py-8">
              <Loader size="lg" />
            </div>}

          {!isLoading && !isEmptySearch && <CityList cities={citiesToShow} currentCityAlias={currentCityAlias} />}
        </div>
      </DialogContent>
    </Dialog>;
};